import { Link } from "react-router-dom"
import React from "react"
import Companycard from "./companyCard.jsx"
import companyData from "../../data/companyData.jsx"

const createCard = data => {
  return <Companycard link={data.link} image={data.image} />
}

export default function ShopByCompany() {
  return (
    <div className="shop-by-company-container">
      <div className="home-heading">
        <h2>Shop by Company</h2>
        <Link to="/shop-by-company" className="link">See All</Link>
      </div>
      <div className="company-cards-container">
        {companyData.map(createCard)}
      </div>
    </div>
  )
}
